import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "beta",
    aws_cognito_region: "eu-west-1",
    aws_cognito_identity_pool_id: "eu-west-1:c9152aba-5723-4e03-92b2-88be689a8dbd",
    aws_user_pools_id: "eu-west-1_9cyiSIsjF",
    aws_user_pools_web_client_id: "n71bdeb3u5dkoj6fqulsa9jkj",
    Auth: {
      identityPoolId: "eu-west-1:c9152aba-5723-4e03-92b2-88be689a8dbd",
      region: "eu-west-1",
      userPoolId: "eu-west-1_9cyiSIsjF",
      userPoolWebClientId: "n71bdeb3u5dkoj6fqulsa9jkj",
    },
    oauth: {
      domain: "whs-safer-beta-mena.auth.eu-west-1.amazoncognito.com",
      redirectSignIn: "https://beta.mena.safer.whs.amazon.dev",
      redirectSignOut: "https://beta.mena.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };

  // BETA/LOCAL ONLY: the Hydra/Cypress integration test authenticates as a SAAM
  // service identity (svc-mw-...-midwaysaam) that has NO email. The identity
  // pool's authenticated role (AmazonQBusinessCognitoRole) requires an `Email`
  // session tag mapped from the token's `email` claim; with no email, the role
  // assume fails ("Invalid identity pool configuration") and Amplify emits
  // signIn_failure so the app never authenticates. The frontend does not use
  // identity-pool (IAM) credentials, so we drop the identity pool on beta/local
  // and let sign-in complete on the User Pool alone. Gamma/prod are unchanged.
  // Local/dev builds resolve beta to "test".
  const stage = "beta".toLowerCase();
  const skipIdentityPool = stage === "beta" || stage === "test";

  if (skipIdentityPool) {
    delete (config as { aws_cognito_identity_pool_id?: string })
      .aws_cognito_identity_pool_id;
    delete (config.Auth as { identityPoolId?: string }).identityPoolId;
  }

  Auth.configure(config);
}
